/**
 * **借贷明细页** —— `/debts/<contraId>`（`AC-Q4.3` 成页 · 批 `111`）
 *
 * ## 🔴 这一页为什么现在才有
 *
 * `AC-Q4.3` 的三类行从批 `82` 起就实现了，但**只有抽屉一个载体**：
 * 从卡片点「明细」能看到，**地址栏里没有它的位置** ⇒ 不能收藏、不能分享、
 * 不能从其它地方（消息 / 报表）深链接进来。批 `94` 甚至把这条写成了"暂不单列"。
 *
 * ⇒ 本页 = 把明细放到一条**可直达的路由**上。内容体与抽屉共用
 * `ui/ContraTimelineBody.tsx`（同一个实现，不是"照着一份再写一份"）。
 *
 * ## ⚠️ 本页刻意不做的事
 *
 * | 不做 | 为什么 |
 * |---|---|
 * | **结算行编辑 / 删除** | 全项目**无此 AC**（`AC-Q4.*` / `AC-Q5.*` 都没有"编辑结算行"）⇒ 破例做就是"没有验收标准的功能"（铁律 6） |
 * | 自己算余额 / 自己排时间 / 自己判三类行 | 全部由 `GET /api/contra/:accountId/timeline` 下发（铁律 24） |
 * | 页内导航吸顶条（`AnchorBar`） | 本页只有一段内容，加吸顶导航等于凭空造一个"锚" |
 */

import type { ReactElement } from 'react';
import { Alert, Button, Card, Stack, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { ContraTimelineBody } from '../ui/ContraTimelineBody.js';

export function ContraDetailPage(): ReactElement {
  const { contraId } = useParams<{ contraId: string }>();
  const navigate = useNavigate();

  // 路由参数缺失（理论上路由不会放行，但 `useParams` 的类型是可选）
  if (contraId === undefined || contraId === '') {
    return (
      <Alert severity="warning" data-testid="contra-detail-missing-id">
        这个链接里没有账户 id。回到「债权债务」重新选一个。
      </Alert>
    );
  }

  return (
    <Stack spacing={2} data-testid="contra-detail-page">
      <Stack direction="row" alignItems="center" spacing={1}>
        <Button
          size="small"
          onClick={() => {
            navigate('/debts');
          }}
          data-testid="contra-detail-back"
        >
          ← 债权债务
        </Button>
        <Typography variant="caption" color="text.secondary">
          借贷明细
        </Typography>
      </Stack>

      <Card>
        <ContraTimelineBody accountId={contraId} />
      </Card>
    </Stack>
  );
}
